import React from "react";

export default function Pipe() {
  return <span style={{ marginRight: `5px`, marginLeft: `5px` }}>|</span>;
}
